import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { logError } from "../lib/logger";

let cache = null;
let listeners = [];

async function fetchColors() {
  try {
    const { data } = await api.get("/status-colors");
    cache = data;
    listeners.forEach((fn) => fn(data));
  } catch (e) {
    logError("Failed to fetch status colors:", e);
  }
}

export function useStatusColors() {
  const [list, setList] = useState(cache || []);
  useEffect(() => {
    if (!cache) fetchColors();
    const fn = (d) => setList(d);
    listeners.push(fn);
    return () => {
      listeners = listeners.filter((x) => x !== fn);
    };
  }, []);
  const map = {};
  (list || []).forEach((s) => {
    map[s.key] = s;
  });
  return { list, map };
}

export function isMidnightJob(job) {
  if (!job?.scheduled_at) return false;
  const sched = new Date(job.scheduled_at);
  return sched.getHours() === 0 && sched.getMinutes() === 0;
}

export function isJobLate(job) {
  if (!job) return false;
  if (job.status !== "agendada") return false;
  if (isMidnightJob(job)) return false; // 00:00 = horário não definido, não conta como atraso
  const sched = new Date(job.scheduled_at);
  return sched.getTime() < Date.now();
}

export function effectiveStatus(job) {
  if (!job) return undefined;
  if (job.status === "agendada" && isMidnightJob(job)) return "horario_invalido";
  if (isJobLate(job)) return "atrasada";
  return job.status;
}
